import { useNavigate, useParams } from 'react-router-dom';

const useWidgetId = (): number => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const widgetId = Number(id);

  if (isNaN(widgetId)) {
    navigate('/404');
  }

  return widgetId;
};

export default useWidgetId;
